export default "__VITE_ASSET__beeef060__"